var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15,
    r: 15,
    fill: "#167A93",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 19.9704V22.183C6.5 22.5237 6.77626 22.8 7.11704 22.8H9.32961C9.49326 22.8 9.65021 22.735 9.76593 22.6193L20.254 12.1312L17.1689 9.04602L6.68073 19.5341C6.56501 19.6498 6.5 19.8067 6.5 19.9704Z",
    stroke: "#167A93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5685 6.64634L22.6537 9.73153L24.1386 8.2467C24.6205 7.76476 24.6205 6.98339 24.1386 6.50146L22.7986 5.16151C22.3167 4.67956 21.5353 4.67956 21.0534 5.16151L19.5685 6.64634Z",
    stroke: "#167A93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.63799c28415be1bbeea17080de4be407.svg";
export { ForwardRef as ReactComponent };